// Function to extract route names and paths from router configuration
export const getRouteOptions = (router) => {
    if (!router || !router.getRoutes) {
        return []
    }
    
    const routes = router.getRoutes()
    const options = []
    const seenNames = new Set()
    
    routes.forEach(route => {
        if (route.name && route.path) {
            // Skip only simple /:id paths, but keep /:cid, /:sandboxId, etc.
            if (route.path.match(/^\/:id$/) || route.path.includes('*')) {
                return
            }   
            // Skip if we've already seen this route name
            if (seenNames.has(route.name)) {
                return
            }
            seenNames.add(route.name)
            options.push({
                value: route.name,
                label: route.name,
                path: route.path
            })
        }
    })
    
    // Sort alphabetically by route name
    return options.sort((a, b) => a.label.localeCompare(b.label))
}

export default [
    {
        name: 'title',
        label: 'Title',
        type: 'text',
        required: true,
        validation: [
            {
                type: 'required',
                errMsg: 'Title is required'
            }
        ]
    },
    {
        name: 'route_name',
        label: 'Route Name',
        type: 'customSingleSelect',
        required: true,
        placeholder: 'Select a route',
        getOptions: getRouteOptions,
        validation: [
            {
                type: 'required',
                errMsg: 'Route name is required'
            }
        ]
    },
    {
        name: 'route_path',
        label: 'Route Path',
        type: 'text',
        required: true,
        placeholder: 'e.g., /admin/users',
        validation: [
            {
                type: 'required',
                errMsg: 'Route path is required'
            }
        ]
    },
    {
        name: 'url',
        label: 'Helpjuice URL',
        type: 'text',
        required: true,
        validation: [
            {
                type: 'required',
                errMsg: 'Helpjuice URL is required'
            },
            {
                type: 'url',
                base:'',
                errMsg: 'Please enter a valid Helpjuice URL'
            }
        ]
    },
    {
        name: 'created_by',
        label: 'Created By',
        type: 'text',
        editable: false,
        visible: false
    },
    {
        name: 'created_at',
        label: 'Created At',
        type: "text",
        editable: false,
        format:"datetime",
        visible: false
    },
    {
        name: 'updated_by',
        label: 'Updated By',
        type: 'text',
        editable: false,
        visible: false
    },
    {
        name: 'updated_at',
        label: 'Updated At',
        type: "text",
        editable: false,
        format:"datetime",
        visible: false
    }
    
]; 